export default __webpack_public_path__ + "static/media/onboard.3127395c.png";